import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { Guide } from '../guide';
import { Router } from '@angular/router';

@Component({
  selector: 'app-guides',
  templateUrl: './guides.component.html',
  styleUrls: ['./guides.component.css']
})
export class GuidesComponent implements OnInit {

  guides: Guide[] = [];
  searchTerm = "";
  searchOption = "name";

  constructor(
    private httpService: HttpService,
    private router: Router
  ) { }

  ngOnInit() {
    this.httpService.getAllGuides().subscribe(res => {
      this.guides = res;
    });
  }

  editGuide(id: number){
    this.router.navigateByUrl("/management/edit-guide/" + id);
  }

}
